import { EAgeRange, EChoirConcertFrequency, EChoirFundingModel, EChoirSize, EChoirStatus, EChoirType, EConcertConditions, EProficiencyLevel, ERehearsalType } from "../../../../../common/types/choir/meta/details";
import messages from "./messages";


export const choirStatusOptions = [
    {
        value: EChoirStatus.FORMING,
        label: messages.forming,
    },
    {
        value: EChoirStatus.OPERATING,
        label: messages.operating,
    },
    {
        value: EChoirStatus.SUSPENDED,
        label: messages.suspended,
    },
    {
        value: EChoirStatus.DISBANDED,
        label: messages.disbanded,
    },
];

export const choirConcertFrequencyOptions = [
    {
        value: EChoirConcertFrequency.WEEKLY,
        label: messages.weekly
    },
    {
        value: EChoirConcertFrequency.MONTHLY,
        label: messages.monthly
    },
    {
        value: EChoirConcertFrequency.EVERY_TWO_MONTHS,
        label: messages.everyTwoMonths
    },
    {
        value: EChoirConcertFrequency.EVERY_THREE_MONTHS,
        label: messages.everyThreeMonths
    },
    {
        value: EChoirConcertFrequency.EVERY_HALF_A_YEAR,
        label: messages.everyHalfAYear
    },
    {
        value: EChoirConcertFrequency.ANNUALLY,
        label: messages.annually
    },
];

export const choirFundingModelOptions = [
    {
        value: EChoirFundingModel.MEMBERSHIP_FEE,
        label: messages.membershipFee
    },
    {
        value: EChoirFundingModel.DONATION_ASSOCIATION_SPONSORED,
        label: messages.donationAssociationSponsored
    },
    {
        value: EChoirFundingModel.PAYMENT,
        label: messages.payment
    },
];

export const choirSizeOptions = [
    {
        value: EChoirSize.SMALL_ENSEMBLE,
        label: messages.smallEnsemble
    },
    {
        value: EChoirSize.ENSEMBLE,
        label: messages.ensemble
    },
    {
        value: EChoirSize.SMALL_CHAMBER_CHOIR,
        label: messages.smallChamberChoir
    },
    {
        value: EChoirSize.CHAMBER_CHOIR,
        label: messages.chamberChoir
    },
    {
        value: EChoirSize.CHOIR,
        label: messages.choir
    },
];

export const choirTypeOptions = [
    {
        value: EChoirType.MENS,
        label: messages.mens,
    },
    {
        value: EChoirType.WOMENS,
        label: messages.womens,
    },
    {
        value: EChoirType.MIXED,
        label: messages.mixed,
    },
];

export const choirAgeRangeOptions = [
    {
        value: EAgeRange.A7,
        label: '7',
    },
    {
        value: EAgeRange.A14,
        label: '14',
    },
    {
        value: EAgeRange.A20,
        label: '20',
    },
    {
        value: EAgeRange.A30,
        label: '30',
    },
    {
        value: EAgeRange.A40,
        label: '40',
    },
    {
        value: EAgeRange.A50,
        label: '50',
    },
    {
        value: EAgeRange.A60,
        label: '60',
    },
    {
        value: EAgeRange.AInf,
        label: '∞',
    },
];

export const choirProficiencyLevelOptions = [
    {
        value: EProficiencyLevel.NONE,
        label: messages.none
    },
    {
        value: EProficiencyLevel.BASIC,
        label: messages.basic
    },
    {
        value: EProficiencyLevel.INTERMEDIATE,
        label: messages.intermediate
    },
    {
        value: EProficiencyLevel.INTERMEDIATE_ADVANCED,
        label: messages.intermediateAdvanced
    },
    {
        value: EProficiencyLevel.ADVANCED,
        label: messages.advanced
    },
]

export const choirConcertConditionsOptions = [
    {
        value: EConcertConditions.QUIET_AUDIENCE,
        label: messages.quietAudience
    },
    {
        value: EConcertConditions.NOISY_AUDIENCE,
        label: messages.noisyAudience
    },
    {
        value: EConcertConditions.INDOOR,
        label: messages.indoor
    },
    {
        value: EConcertConditions.OUTDOOR,
        label: messages.outdoor
    },
    {
        value: EConcertConditions.LOCAL_CONCERTS,
        label: messages.localConcerts
    },
    {
        value: EConcertConditions.FREQUENT_TRAVEL,
        label: messages.frequentTravel
    },
];

export const choirRehearsalTypeOptions = [
    {
        value: ERehearsalType.REHEARSAL,
        label: messages.rehearsal
    },
    {
        value: ERehearsalType.SECTIONAL,
        label: messages.sectional
    },
    {
        value: ERehearsalType.TUTORING,
        label: messages.tutoring
    },
];
